import instance from './http'
// import qs from 'qs'

//常用api
const base = {
    online: 'http://47.97.193.160:8080',
    offline: 'https://api2.epctfm.com',//http://192.168.2.88:5000  http://192.168.18.88:5000    http://api2.epctfm.com
};

//登录模块
const  login = {
    captcha () {
        return instance.get(`/captcha`,{
            headers: {
                'Content-Type': 'application/json',
            }
        })
    },
    loginIn (params) {
        return instance.post(`/token`, params);
    },
};
const userSelf = {
  personalCenter(encryptData){
    return instance.get(`/user`,{
      params: encryptData
    })
  },
  changePwd(encryptData){
    return instance.put(`/user/pwd`,'',{
      params: encryptData,
    })
  }
};

const systemInfo = {
  getSysId (encryptData) {
      return instance.get(`/project/info`,{
          params: encryptData,
      });
  },
  floor_tem_hum (sysId, equId, encryptData){
    return instance.get(`/project/systems/${sysId}/${equId}`,{
        params: encryptData,
    })
  },
  indoor_params(encryptData) {//室内参数
    return instance.get(`project/indoor`,{
      params: encryptData,
    })
  },
  machine_info(encryptData) {
    return instance.get(`/project/chiller_info`, {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      params: encryptData,
    })
  },
  SumEelec(encryptData) {
    return instance.get(`/project/elect_sum`,{
      header: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      params:encryptData
    })
  },
  coolingSysElec(encryptData) {
    return instance.get(`/project/elect`,{
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      params: encryptData,
    })
  }
};

const weather = {
    getWeather (query_data) {
        return instance.get(`/weather/武汉市`, {
            data: '',
            params: query_data,
        })
    },
};
const systemCool = {
  openFreezer(code,encryptData) {
    return instance.post(`/equipment/control/open/${code}`,encryptData,{
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },
  closeFreezer(code,encryptData) {
    return instance.post(`/equipment/control/close/${code}`,encryptData,{
      headers: {
        'Content-Type': 'application/json',
      }
    })
  }
};
const userManage = {
    getUser (encryptData) {
        return instance.get(`/users`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            params: encryptData,
        })
    },
    searchUser (encryptData, search_name) {
        return instance.get(`/users/${search_name}`,{
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          params: encryptData,
        })
    },
    addSubmit (encryptData) {
        return instance.post(`/user`,'',{
          headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          params: encryptData
        })
    },
    editSubmit (encryptData,user_id) {
        return instance.put(`/users/${user_id}`, '', {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            params: encryptData,
        })
    },
    deleteSubmit (encryptData, user_id) {
        return instance.delete(`/users/${user_id}`,{
            headers: {
                'Authorization': '',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: '',
            params: encryptData,
        })
    }
};
const projectMan = {
    get_all_pro (encryptData) {
        return instance.get(`/projects`,{
            headers:{
                'Content-Type': 'application/json'
            },
            params: encryptData,
        })
    },
    operatingInfo (proId, equCode, encryptData) {
        return instance.get(`/equipment/record/${proId}/${equCode}`,{
            headers: {
                'Content-Type': 'application/json'
            },
            params: encryptData,
        })
    },
    addEquipment (encryptData) {
        return instance.post(`/project/equ`, '',{
            headers: {
                'Content-Type' : 'application/x-www-form-urlencoded'
            },
            params: encryptData
        })
    },
    addProject (encryptData) {
        return instance.post(`/project`, '', {
            headers: {
                'Content-Type' : 'application/x-www-form-urlencoded'
            },
            params: encryptData
        })
    },
    delProject (proName, encryptData) {
        return instance.delete(`/project/${proName}`, {
            headers: {
                'Content-Type' : 'application/x-www-form-urlencoded'
            },
            data: '',
            params: encryptData,
        })
    },
    delEquipment (proName, equCode, encryptData) {
        return instance.delete(`/project/equ/${proName}/${equCode}`,{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: '',
            params: encryptData,
        })
    }

};
const weaElcMan = {
    obtainData (encryptData) {
        return instance.get(`/energy`,{
            params: encryptData,
        })
    },
    entryData (encryptData) {
        return instance.post(`/energy`,encryptData,{
            headers: {
                'Content-Type': 'application/json',
            },
            data: '',
        })
    }
};
const alarmInfo = {
    obtainData (encryptData) {
        return instance.get(`/project/warnings`,{
            headers: {
                'Content-Type' : 'application/x-www-form-urlencoded',
            },
            params: encryptData,
        })
    },
    obtainAlarm (encryptData) {
      return instance.get(`/project/alarm`,{
        headers: {
          'Content-Type': 'application/json',
        },
        params: encryptData,
      })
    },
    editSolved (row_id,encryptData) {
        return instance.put(`/project/warnings/${row_id}`,'',{
            headers: {
                'Content-Type' : 'application/x-www-form-urlencoded'
            },
            params: encryptData,
        })
    }
};
const runningReport = {
  obtainData(encryptData,sysId) {
    return instance.get(`/project/operation_report/${sysId}`,{
      params: encryptData,
    })
  }
};
const systemVav={
    getVav(encryptData){
        return instance.get(`/project/vav`,{
            params: encryptData,
        })
    }
}
const equipInfo={
    getEquip(encryptData){
        return instance.get(`/project/ledger`,{
            params: encryptData,
        })
    },
    deleteEquip(encryptData){
        return instance.delete(`/project/ledger`,{
            headers: {
                'Content-Type' : 'application/x-www-form-urlencoded',
            },
            params: encryptData,
            data:''

        })
    },
    modifyEquip(encryptData){
        return instance.put(`/project/ledger`,encryptData,{
            headers: {
                'Content-Type' : 'application/json'
            },
        })
    },
    addEquip(encryptData){
        return instance.post(`/project/ledger`,encryptData,{
            headers: {
                'Content-Type' : 'application/json'
            },
        })
    },

}
const filterInfo={
    getFilter(encryptData){
            return instance.get(`/project/attachments`,{
                headers: {
                    'Content-Type' : 'application/json'
                },
                params: encryptData,
                data:""
            })
    },
    uploadFile(encryptData){
        return instance.post(`/project/attachment`,encryptData,{
            headers: {
                'Content-Type' : 'multipart/form-data'
            },
        })
    },
    file_download(encryptData,id){
        return instance.get(`/project/attachments/${id}`,{
            headers: {
                'Content-Type' : 'application/json'
            },
            params: encryptData,
            data:""
        })
    },
    file_delete(encryptData,id){
        return instance.delete(`/project/attachments/`+id,{
            headers: {
                'Content-Type' : 'application/json'
            },
            data:encryptData
        })
    }
}



export {
    base,
    login,
    userSelf,
    systemInfo,
    weather,
    systemCool,
    userManage,
    projectMan,
    weaElcMan,
    runningReport,
    systemVav,
    alarmInfo,
    equipInfo,
    filterInfo,
};
